module.exports = "pegasus_template/assets/graycircle-pinterest.gif";